<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <!-- <i-col span="6">
              <form-item label="转让方名字" prop="giveName">
                <Input
                  v-model="query.giveName"
                  clearable
                  placeholder="请输入转让方名字"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="转让方身份证号" prop="giveCardNo">
                <Input
                  v-model="query.giveCardNo"
                  clearable
                  placeholder="请输入转让方身份证号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="受让方名字" prop="getName">
                <Input
                  v-model="query.getName"
                  clearable
                  placeholder="请输入受让方名字"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="受让方身份证号" prop="getCardNo">
                <Input
                  v-model="query.getCardNo"
                  clearable
                  placeholder="请输入受让方身份证号"
                />
              </form-item>
            </i-col> -->
            <i-col span="6">
              <form-item label="不动产单元号" prop="estateUnitNo">
                <Input
                  v-model="query.estateUnitNo"
                  clearable
                  placeholder="请输入不动产单元号"
                />
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isLoading"
          :data="tableData"
          stripe
          ref="table"
          @on-selection-change="handleSelect"
        >
          <template slot-scope="{ row, index }" slot="view">
            <span @click.stop="clickPic(row)">[查看]</span>
          </template>
          <!-- <template slot-scope="{ row, index }" slot="action">
            <span @click="handleClickDetail(row, 'detail')" class="action"
              >[查看]</span
            >
          </template> -->
          <!-- <template slot-scope="{ row, index }" slot="transferType">
            <span v-if="row.transferType">{{typeList[row.transferType - 1].type}}</span>
          </template> -->
        </i-table>
        <preview-img
            :currentIndex="0"
            :imgArr="showPreview.list"
            v-if="showPreview.show"
            v-on:closePreview="closePreview"
          ></preview-img>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import pageHead from "../../../../components/head";
import PreviewImg from "@/components/previewImg";
import api from "../../../../api/index";
const {
  PromiseFileList,
  download1,
  saveType,
  dataCollectionExport,
  deleteCollectionBatch,
} = api;
export default {
  name: "fileLetter",
  components: {
    pageHead,
    PreviewImg,
  },

  data() {
    return {
      checkMsg: "",
      checkedId: "",
      modalTitle: "",
      showPreview: {
        show: 0,
        list: [],
      }, //预览图片
      typeList: [
        {
          index: 1,
          type: "买卖",
        },
        {
          index: 2,
          type: "离婚析产",
        },
        {
          index: 3,
          type: "赠与",
        },
        {
          index: 4,
          type: "直系亲属",
        },
        {
          index: 5,
          type: "婚内夫妻财产约定",
        },
        {
          index: 6,
          type: "其他",
        },
      ],
      query: {
        // giveName: "",
        // giveCardNo: "",
        // getName: "",
        // getCardNo: "",
        estateUnitNo:'',
        // transferType:''
      },
      giveName: "",
      giveNameList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: "附件列表",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "搜索",
          type: "search",
        },
      ],
      tableHeader: [
        {
          type: "selection",
          width: 70,
          align: "center",
        },
        {
          title: "不动产单元号",
          key: "estateUnitNo",
        },
        {
          title: "不动产权号",
          key: "estateNo",
        },
        {
          title: "附件名称",
          key: "promiseFiledName",
        },
        {
          title: "凭证",
          slot: "view",
        },
      ],
      tableData: [],
      selectedList: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    closePreview() {
        console.log("========closePreview==========");
        this.showPreview.show = 0;
      },
      clickPic(val) {
        this.showPreview.list = [];
        console.log(val);
        // val.picArr.length > 0 &&
        //   val.picArr.forEach((item) => {
        //     this.showPreview.list.push({ isHeight: true, path: item });
        //   });
        this.showPreview.list = [{ isHeight: true, path: val.fileUrl }]
        console.log(this.showPreview.list);
        this.showPreview.show = 1;
      },
    handleBtn(type) {
      if (type == "reset") {
        this.pageNum = 1;
        this.$refs.search.resetFields();
        this.getLandTransferList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getLandTransferList();
      }
    },

    handleSelect(selection) {
      this.selectedList = [];
      (this.giveNameList = []), (this.giveName = "");
      console.log(selection);
      selection.forEach((item) => {
        this.selectedList.push(item.id);
        this.giveNameList.push(
          item.giveName.replace(/(\d{6})(\d{6})(\w{7})/g, "$1 $2 $3 ")
        );
      });
      console.log(this.selectedList);
    },
    handleClickDetail1(item) {
      this.$router.push({
        name: "landTransferDetail",
        query: { estateCollectionId: item.id },
      });
    },
    async handleDelete(id) {
      let res = await this.$delete(deleteCollectionBatch, {
        idList: id,
      });
      if (res.isSucceed) {
        this.$Message.success("删除成功");
        this.getLandTransferList();
      }
    },
    async handleClickDetail(item, type) {
      // console.log(item, type);
      if (type == "detail") {
        let res = await this.$get(download1('cdh'), {
          id: item.id
        });
        if(res.code == 1){
          let url = res.newPrimaryKeys.attachmentDetail.attachmentUrl
          window.open(url)
        }
      } else if (type == "del") {
        console.log("del", item.id);
        this.handleDelete(item.id);
      } else {
        if (type == "pass") {
          this.modalTitle = "审核通过说明(选填)";
          (this.checkMsg = "审核通过"), (this.status = 1);
        } else {
          this.modalTitle = "审核未通过说明(必填)";
          this.status = 0;
        }
        this.giveName = item.giveName.replace(
          /(\d{6})(\d{6})(\w{7})/g,
          "$1 $2 $3 "
        );
        this.checkedId = item.id;
        this.showCheckMsg = true;
      }
    },
    pageChange(val) {
      this.pageNum = val;
      this.getLandTransferList();
    },
    async getLandTransferList() {
      this.isLoading = true;
      try {
        let res = await this.$get(PromiseFileList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.query,
        });
        console.log(this.query);
        this.tableData = res.rows;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    },
  },

  created() {
    this.getLandTransferList();
    console.log(this.$route);
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}
.time {
  width: 100%;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .success {
    color: #ff7b44;
  }
  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}

.statistics {
  padding: 10px 0;
  text-align: right;
}

.estateTitle {
  color: #ff7b44;
  font-weight: bold;
}

.estateNO {
  color: #ff7b44;
  font-weight: 400;
  background: #ffefe9;
  margin: 0 15px 10px 0;
}
</style>